import React from 'react';
import {FormControlLabel, FormGroup, Paper, PaperProps, Typography} from '@mui/material';
import {styled} from "@mui/material/styles";

const TogglePanelRowFont = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '1.14eem',
  lineHeight: '160%',
  letterSpacing: '0.01em'
}));

const TogglePanelRowContent = styled(FormControlLabel)(() => ({
  justifyContent: 'space-between',
  margin: 0,
}));

// Extends PaperProps (minus the native `title` attribute) since remaining
// props are spread onto Paper, and styled() wraps this component (requiring
// it to accept the props Paper/MUI's styled utility inject, e.g. className).
interface TogglePanelProps extends Omit<PaperProps, 'title'> {
  title?: string;
  toggleComponent: React.ReactElement;
}

const TogglePanel = (props: TogglePanelProps) => {
  const { title, toggleComponent, ...remainingProps } = props;

  return (
    <Paper {...remainingProps}>
      <FormGroup>
        <TogglePanelRowContent
          labelPlacement='start'
          label={
            <TogglePanelRowFont variant='h6' color="textPrimary">{title}</TogglePanelRowFont>
          }
          control={toggleComponent}
        />
      </FormGroup>
    </Paper>
  );
};

export default TogglePanel;
